import { Component, OnInit, ViewChild } from '@angular/core'
import { UntypedFormBuilder, Validators } from '@angular/forms'
import { MatAccordion } from '@angular/material/expansion'
import { ActivatedRoute } from '@angular/router'
import { CommonService } from 'src/app/services/common.service'
import { OrderService } from 'src/app/services/order.service'
import { ProductService } from 'src/app/services/product.service'
import { FilterAttributeData } from 'src/app/types/products'
import * as _ from 'lodash'

@Component({
    selector: 'gw-chkout-travel-restrictions',
    templateUrl: './travel.restrictions.component.html',
    styleUrls: ['./travel.restrictions.component.scss'],
    standalone: false
})

export class TravelRestrictionsComponent implements OnInit {
  public type = 'restrictions'
  public restrictionsForm = this.formBuilder.group({
    citizenship: ['US', Validators.required],
    residency: ['', Validators.required],
    country: ['', Validators.required],
  })
  public restrictions
  public loading: boolean = false
  public visas_cta: boolean = false

  @ViewChild(MatAccordion) accordion: MatAccordion

  constructor(
    private formBuilder: UntypedFormBuilder,
    private commonService: CommonService,
    private productService: ProductService,
    private orderService: OrderService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.saveParams()
  }

  private saveParams() {
    this.orderService.getCart()
    this.activatedRoute.data.subscribe((response) => {
      this.type = response.type
    })
    let params = this.activatedRoute.snapshot.queryParams
    let current = this.orderService.orderForm.controls.params.value
    this.orderService.orderForm.controls.params.patchValue(_.merge(params, current))
    this.orderService.saveCart()
  }

  checkCountry(list: {iataCode: string, areaType: string}[]) {
    return list.some(
      item => item.iataCode == this.restrictionsForm.value.citizenship && item.areaType == 'country'
    )
  }

  public onCountryUpdated(country_code: string) {
    this.loading = true

    if (this.accordion) this.accordion.closeAll()

    this.commonService.getCountryRestrictions(country_code)
      .subscribe(response => {
        this.restrictions = response
        this.restrictions.areaAccessRestriction.entry.banned = this.restrictions.areaAccessRestriction.entry.ban == 'No' ? false : this.checkCountry(this.restrictions.areaAccessRestriction.entry.bannedArea)
      })
    this.loading = false

    this.getCountryProducts()
  }

  public getCountryProducts() {
    let product: FilterAttributeData = {
      citizenship: this.restrictionsForm.value.citizenship,
      residency: this.restrictionsForm.value.residency,
      residence_country: 'US',
      type: 'visa',
      country: this.restrictionsForm.value.country
    }

    this.productService.getProducts(product)
      .subscribe((products) => {
        this.visas_cta = !products.service_unavailable
      })
  }
}
